// import { Button, Spin, Table } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import Table from "../../../../../core/common/dataTable/index";

interface SubCategory {
  id: number;
  name: string;
  category: number;
  category_name: string;
  has_call_back_time: boolean;
}

const SedSubCategory = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [data, setData] = useState<SubCategory[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState<string>("");
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) =>
        (ability as { action: string; subject: string }).action === action &&
        (ability as { action: string; subject: string }).subject === subject,
    );
  };

  // const fetchData = async (
  //   page: number,
  //   pageSize: number,
  //   searchText: string,
  // ) => {
  //   const queryParams = new URLSearchParams({
  //     page: page.toString(),
  //     page_size: pageSize.toString(),
  //     search: searchText || "",
  //     // name: appliedFilters.name || "",
  //   });
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${webApi}/sed/sed_ticket_category/?${queryParams.toString()}`,
  //       options,
  //     );
  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       if (errorData.code === "token_not_valid") {
  //         navigate("/academic/sri-chaitanya/crm/landing-page");
  //       }
  //       throw new Error(errorData.detail || "Failed to fetch user data");
  //     }
  //     const data = await response.json();
  //     setData(data.results);
  //     setCurrentPage(data.current_page_number);
  //     setTotalCount(data.total_count);
  //     setPageSize(data.default_page_size);
  //   } catch (error) {
  //     console.error("Error in sed Category", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchData = async (page: number, size: number, search: string) => {
    setIsLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        page_size: String(size),
        search,
      });
      const response = await fetch(
        `${webApi}/sed/sed_ticket_subcategory/?${queryParams}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      );
      const result = await response.json();
      if (!response.ok) {
        if (result.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
          return;
        }
        throw new Error(result.detail);
      }
      setData(result.results ?? []);
      setCurrentPage(result.current_page_number ?? 1);
      setTotalCount(result.total_count ?? 0);
      setPageSize(result.default_page_size ?? 10);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(!checkPermission("view_sedticketsubcategory", "sedticketsubcategory")){
      navigate(routes.crmLandingPage)
    } else {
      fetchData(currentPage, pageSize, searchText);
    }
  }, [userPermissions]);

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    setCurrentPage(1);
    fetchData(1, pageSize, value);
  };

  const columns = [
    {
      title: "Sub Category",
      dataIndex: "name",
    },
    {
      title: "Category",
      dataIndex: "category_name",
    },
    ...(checkPermission("change_sedticketsubcategory", "sedticketsubcategory")
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_text: any, record: { id: any }) => (
              <div className="d-flex align-items-center">
                <Link
                  className="btn btn-icon btn-sm btn-soft-info rounded-pill"
                  to={routes.SEDEditSubCategory}
                  state={{ id: record.id }}
                >
                  <i className="feather-edit" />
                </Link>
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">SED Sub Category </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Sub Category
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {checkPermission(
                "add_sedticketsubcategory",
                "sedticketsubcategory",
              ) && (
                <Link to={routes.SEDAddSubCategory} className="btn btn-primary">
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Sub Category
                </Link>
              )}
            </div>
          </div>

          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Sub Category List</h4>
              <div className="d-flex align-items-center flex-wrap"></div>
              <div className="d-flex align-items-center flex-wrap ms-auto gap-2">
                {/* <div className="mb-1">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    Filter
                  </button>
                  {showFilter && (
                    <div
                      className="card mt-3 shadow-sm"
                      style={{
                        width: "500px",
                        position: "absolute",
                        right: 0,
                        zIndex: 1000,
                        borderRadius: "12px",
                      }}
                    >
                      <form>
                        <div className="d-flex align-items-center border-bottom p-3">
                          <h4 className="mb-0 me-auto">Filter</h4>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowFilter(false)}
                          />
                        </div>

                        <div className="p-3">
                          <div className="row">

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Category
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={filters.branch}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      branch: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>


                          </div>
                        </div>

                        <div className="p-3 border-top d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light me-3"
                            onClick={handleResetClick}
                          >
                            Reset
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApplyClick}
                          >
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={data}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize,
                    total: totalCount,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    locale: { items_per_page: "" },
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total}`,
                    position: ["bottomRight"],
                  }}
                  onChange={handleTableChange}
                  onSearch={handleSearch}
                  searchText={searchText}
                  loading={isLoading}
                  rowKey="id"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SedSubCategory;
